import React, {Component} from 'react';
import { withRouter } from 'react-router-dom'; //Link
import { compose } from 'recompose';
import {SignUpLink} from '../SignUp';
import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';
import './index.css';
// import {
//         Alignment,
//         AnchorButton,
//         Classes,
//         Navbar,
//         NavbarGroup,
//         NavbarHeading,
//         NavbarDivider,
//         Divider
//   } from "@blueprintjs/core";


  const SignInPage = () => (
      <div className="margin-left">
                <h3>Sign in</h3>
                <SigninForm />
                <SignUpLink />
      </div>
  );

  const INITIAL_STATE = {
      email: '',
      passowrd: '',
      error: null
  }

  class SignInFormBase extends Component {
      constructor(props){
          super(props);

          this.state = {...INITIAL_STATE};
      }

    onSubmit = event => {
      const {email, password} = this.state;

      this.props.firebase.doSignInWithEmailandPassword(email, password)
      .then(() =>{
          this.setState({...INITIAL_STATE});
          this.props.history.push(ROUTES.HOME);
          console.log("User logged in");
      })
      .catch(error => {
          this.setState({error});
      });

      event.preventDefault();
    };

    onChange = event => {
        this.setState({ [event.target.name] : event.target.value});
    };

    render () {
            const {email, password, error} = this.state;

            const isInvalid = password === '' || email === '';

            return(
                <form onSubmit={this.onSubmit}> 
                    <input 
                            className="bp3-input"
                            name="email"
                            value = {email}
                            onChange = {this.onChange}
                            type = "text"
                            placeholder = "Email" 
                        />
                        <input 
                            className="bp3-input"
                            name="password"
                            value = {password}
                            onChange = {this.onChange}
                            type = "password"
                            placeholder = "Password" 
                        />

                        <button className='margin-bottom' disabled={isInvalid} type="submit">Sign In</button>

                        {error && <p>{error.message}</p>}
                </form>
            )
        }
    }


const SigninForm = compose(
    withRouter, 
    withFirebase,
)(SignInFormBase);

export { SigninForm };

export default SignInPage;
